export const cleanIconProps = (props) => {
  const newProps = {...props};
  delete newProps.circleStyle;
  return newProps;
}